import React, { useState } from "react";
import { Form, PrimaryButton } from "@bloomberg/media-ui-core";
import styles from "./styles.module.css";
import FormHeader from "~components/Portfolio/PortfolioForm/FormHeader";
import {
  FORM_ACTION,
  WATCHLIST_DELETE_FAILURE_TEXT,
} from "~constants/Portfolio";
import Notification from "~components/Notification";

type FormFooterProps = {
  onClick: () => void;
  loading: boolean;
};

function FormFooter(props: FormFooterProps) {
  const { onClick, loading } = props;

  return (
    <div className={styles.footer}>
      <PrimaryButton
        className={styles.button}
        type="button"
        bold={false}
        fullWidth={true}
        loading={loading}
        onClick={onClick}
        variant="error"
        title="Permanently Delete Watchlist"
      >
        <span className={styles.buttonText}>
          Yes, Permanently Delete Watchlist
        </span>
      </PrimaryButton>
    </div>
  );
}

type DeleteFormProps = {
  portfolioName: string;
  onFormEvent: (action: string) => Promise<void>;
};

export default function DeleteForm(props: DeleteFormProps) {
  const { portfolioName, onFormEvent } = props;
  const [deleteActionFailed, setDeleteActionFailed] = useState(false);
  const [deletingPortfolio, setDeletingPortfolio] = useState(false);

  const handleCancelClick = () => {
    setDeleteActionFailed(false);
    // we don't have to wait for event handler to complete
    onFormEvent(FORM_ACTION.CANCEL).catch(console.error);
  };

  const handleDeleteClick = () => {
    // reset flags
    setDeletingPortfolio(true);
    setDeleteActionFailed(false);

    onFormEvent(FORM_ACTION.DELETE_PERMANENTLY)
      .catch((error) => {
        console.error(error);

        // show notification on failure
        setDeleteActionFailed(true);
      })
      .finally(() => {
        setDeletingPortfolio(false);
      });
  };

  return (
    <Form
      className={styles.portfolioForm}
      onSubmit={() => {
        return false;
      }}
    >
      <FormHeader
        title="Delete Watchlist"
        showDelete={false}
        onCancelClick={handleCancelClick}
      />
      <div className={styles.body}>
        {deleteActionFailed && (
          <Notification
            text={WATCHLIST_DELETE_FAILURE_TEXT}
            variant="default"
            title="Error"
          />
        )}

        <div className={styles.text}>
          <div className={styles.line}>
            Are you sure you want to remove the watchlist:
          </div>
          <div className={styles.name}>{portfolioName}</div>
          <div className={styles.line}>This action cannot be undone.</div>
        </div>
      </div>
      <FormFooter onClick={handleDeleteClick} loading={deletingPortfolio} />
    </Form>
  );
}
